import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ApiService } from 'core/api/api.service';
import { ExportUtilsService } from 'core/export-utils/export-utils.service';
import { AppInfoService } from 'core/app-info/app-info.service';
import { AppLocalization } from 'src/app/modules/shared/entities/app-localization';

@Injectable({
  providedIn: 'root'
})
export class ConsignedWarehouseService {
  private urls = {
    warehouseList: '/api/consigned/accountmanager/',
    warehouseProducts: '/api/consigned/warehouseproducts/',
    warehouseSave: '/api/consigned/save',
    printWarehouseReport: '/api/consigned/printConsignedInventory/'
  };
  whList;
  cwLoaded = {
    whList: false,
    productList: false
  };
  warehouseList$ = new Subject();
  private appStrings: AppLocalization;

  constructor(
    private apiService: ApiService,
    private exportUtilsService: ExportUtilsService,
    private appInfoService: AppInfoService,
  ) {
    this.appStrings = this.appInfoService.appStrings;
  }

  /**
   * Gets warehouses list for an account manager and emits the value on warehouseList
   * @param accountManagerId account manager id
   */
  getWHList(accountManagerId: string) {
    this.apiService.get(this.urls.warehouseList + accountManagerId).subscribe(result => {
      this.whList = result;
      this.cwLoaded.whList = true;
      this.warehouseList$.next(result);
    });
  }

  /**
   * Gets warehouses list for an account manager
   * @param employeeId employee id
   */
  getWarehouseListForAM(employeeId: string) {
    return this.apiService.get(this.urls.warehouseList + employeeId);
  }

  /**
   * Gets products list from a warehouse
   * @param warehouse warehouse
   * @param quoteId quote id
   * @param searchPayload search payload
   * @param callback callback
   */
  getProductsForWh(warehouseCode, quoteId, searchPayload, callback: (...args: any[]) => any) {
    const payload = {
      warehouseCode,
      quoteId,
      sort: searchPayload.sort,
      page: searchPayload.page
    };

    this.apiService.post(this.urls.warehouseProducts, payload).subscribe(result => {
      callback(result);
    });
  }

  updateConsignedWarehouseValues(quoteId, warehouseDetails, selectedItems, callback, errorCallback) {
    let tmpElement;
    const payload = {
      quoteId,
      consignedWarehouse: {
        warehouseCode: warehouseDetails.value,
        warehouseName: warehouseDetails.label
      },
      consignedWarehouseItems: []
    };
    selectedItems.forEach((count, key) => {
      tmpElement = key;
      tmpElement.selectedQuantity = Number(count);
      payload.consignedWarehouseItems.push(tmpElement);
    });
    this.apiService.post(this.urls.warehouseSave, payload)
      .subscribe(result => callback(result), () => errorCallback());
  }

  /**
   * Opens warehouse report in a new file
   * @param warehouseCode warehouse code
   * @param employeeId employee id
   */
  getWarehouseReport(warehouseCode: string, employeeId: string) {
    const printWindow = this.exportUtilsService.openPrintFile(this.appStrings.label_exportingConsignedReport);
    this.apiService.getBlob(this.urls.printWarehouseReport + warehouseCode + `?employeeId=${employeeId}`)
      .subscribe((data: BlobPart) => this.exportUtilsService.printFile(data, printWindow));
  }
}
